import React from "react";
import { observer } from "mobx-react";
import { Row, Col,  ButtonToolbar, ToggleButtonGroup, ToggleButton } from "react-bootstrap";
import { Line } from 'react-chartjs-2';
import { Report1Item } from "../../../../stores";
import { ru } from 'date-fns/locale';
import { formatShortDate, formatMoney, formatDateToMask } from "../../../../common/Formatting";

interface IProps {
    data: Report1Item[];
    dateFrom: Date;
    dateTo: Date;
}
interface IState {
    splitBy: "month" | "week" | "day" | "year";
}

@observer
export class BaseChart extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            splitBy: "month"
        };
    }

    private changePeriod = (value: "month" | "week" | "day" | "year") => {
        this.setState({
            splitBy: value
        });
    }
    render() {

        const labels: any[] = [];
        const localize: any = ru.localize;
        switch (this.state.splitBy) {
            case "year":
                for (let d = new Date(this.props.dateFrom); d <= this.props.dateTo; d.setFullYear(d.getFullYear() + 1)) {
                    labels.push({
                        key: formatDateToMask(d, "yyyy"),
                        label: formatDateToMask(d, "yyyy"),
                        sum: 0,
                        count: 0
                    })
                }
                break;
            case "month":
                for (let d = new Date(this.props.dateFrom); d <= this.props.dateTo; d.setMonth(d.getMonth() + 1)) {
                    labels.push({
                        key: formatDateToMask(d, "MM.yyyy"),
                        label: `${localize.month(d.getMonth(), { width: 'abbreviated' })}, ${d.getFullYear()}`,
                        sum: 0,
                        count: 0
                    })
                }
                break;
            case "day":
                for (let d = new Date(this.props.dateFrom); d <= this.props.dateTo; d.setDate(d.getDate() + 1)) {
                    labels.push({
                        key: formatDateToMask(d, "dd.MM.yyyy"),
                        label: `${formatShortDate(d)}, ${localize.day(d.getDay(), { width: 'abbreviated' })}`,
                        sum: 0,
                        count: 0
                    })
                }
                break;
        }



        this.props.data.forEach(item => {
            const year = new Date(item.date).getFullYear();
            const month = new Date(item.date).getMonth();
            // let week = new Date(item.date).;
            const day = new Date(item.date).getDay();
            let key = "";
            let label = "";
            switch (this.state.splitBy) {
                case "year":
                    key = formatDateToMask(item.date, "yyyy");
                    label = `${year}`;
                    break;
                case "month":
                    key = formatDateToMask(item.date, "MM.yyyy");
                    label = `${localize.month(month, { width: 'abbreviated' })}, ${year}`;
                    break;
                case "day":

                    key = formatDateToMask(item.date, "dd.MM.yyyy");
                    label = `${formatShortDate(item.date)}, ${localize.day(item.date.getDay, { width: 'abbreviated' })}`;
                    break;
            }
            const index = labels.findIndex(w => w.key == key);
            let sum = 0;
            let count = 0;
            item.managers.forEach(man => {
                sum += man.sum;
                count += man.ordersCount;
            });
            if (index == -1) {
                labels.push({
                    key: key,
                    label: label,
                    sum: sum,
                    count: count
                })
            }
            else {
                labels[index].sum += sum;
                labels[index].count += count;
            }

        });

        const data = {

            datasets: [
                {
                    label: 'Продажи за период, сумма',
                    fill: false,
                    backgroundColor: 'rgba(75,192,192,0.4)',
                    borderColor: 'rgba(75,192,192,1)',
                    pointBorderColor: 'rgba(75,192,192,1)',
                    pointBackgroundColor: '#fff',
                    pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                    pointHoverBorderColor: 'rgba(220,220,220,1)',
                    data: labels.map(w => formatMoney(w.sum)),
                    yAxisID: 'y-axis-1',
                },
                {
                    label: 'Продажи за период, количество',
                    fill: false,
                    backgroundColor: 'rgba(75,192,192,0.4)',
                    borderColor: '#ffc343',
                    pointBorderColor: 'rgba(75,192,192,1)',
                    pointBackgroundColor: '#fff',
                    pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                    pointHoverBorderColor: 'rgba(220,220,220,1)',
                    data: labels.map(w => w.count),
                    yAxisID: 'y-axis-2'
                }
            ]
        };

        const options = {
            responsive: true,
            tooltips: {
                mode: 'label'
            },
            elements: {
                line: {
                    fill: false
                }
            },
            scales: {
                xAxes: [
                    {
                        display: true,
                        gridLines: {
                            display: true
                        },
                        labels: [...labels.map(w => w.label)]
                    }
                ],
                yAxes: [
                    {
                        type: 'linear',
                        display: true,
                        position: 'left',
                        id: 'y-axis-1',
                        gridLines: {
                            display: true
                        },
                        labels: {
                            show: true
                        }
                    },
                    {
                        type: 'linear',
                        display: true,
                        position: 'right',
                        id: 'y-axis-2',
                        gridLines: {
                            display: false
                        },
                        labels: {
                            show: true
                        }
                    }
                ]
            }
        };

        return <Row>
            <Col sm={1}>
                <br />
                <br />
                <ButtonToolbar >
                    <ToggleButtonGroup value={this.state.splitBy}
                        type="radio" name="options" defaultValue={"month"} vertical size="sm"
                        onChange={this.changePeriod} style={{ zIndex: 0 }}>
                        <ToggleButton value={"year"}>Год</ToggleButton>
                        <ToggleButton value={"month"}>Месяц</ToggleButton>
                        <ToggleButton value={"day"}>День</ToggleButton>
                    </ToggleButtonGroup>
                </ButtonToolbar>
            </Col>
            <Col sm={11}>
                <Line
                    data={data}
                    options={options} />
            </Col>
        </Row >
    }
}